import React from 'react';
import { useMutation } from 'react-query';
import { Button, Pane, Text, Label, TextInput, Spinner } from 'evergreen-ui';
import { Header, Support } from '../../components';
import mobileRequests from '../../queries/mobile';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser } from '../../store/authSlice';
import OtpInput from 'react-otp-input';
import styled from 'styled-components';

const PrefixInputField = styled(TextInput)`
  font-size: 0.9rem;
  border-radius: 5px;
  border: none;
  color: #a7aaac;
  border-radius: 10px;
  background-color: #2b2d2e;
  width: 60px;
  position: absolute;
  padding: 25px 12px;
  margin-top: 4px;
  z-index: 5;
`;

const NumberInputField = styled(TextInput)`
  font-size: 0.9rem;
  border-radius: 5px;
  border: none;
  color: #a7aaac;
  border-radius: 10px;
  background-color: #2b2d2e;
  padding: 25px 12px 25px 80px;
  width: 100%;
`;

const CustomOTPInput = styled(OtpInput)`
  input {
    background: #283037;
    color: white;
    border-radius: 10px;
    padding: 20px 15px;
    border: 1px solid #384148;
  }
  flex: 1;
  justify-content: center;
`;

const NumberInsertionForm = ({ changePage }) => {
  const token = useSelector(state => state.authentication.token);
  const [prefix, setPrefix] = React.useState('+44');
  const [number, setNumber] = React.useState('');
  const addMobileQuery = useMutation(mobileRequests.addRequest, {
    useErrorBoundary: true,
  });

  const addMobile = async () => {
    try {
      if (addMobileQuery.isLoading) return;
      if (!prefix || !number) return;
      const result = await addMobileQuery.mutateAsync({
        phoneNumber: `${prefix}${number}`,
        token,
      });
      if (result) {
        changePage();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const changePrefix = e => {
    if (e.target.value.length > prefix.length) {
      // added a digit
      const lastChar = e.target.value.slice(-1);
      if (!lastChar.match(/[0-9]/) && (lastChar !== '+' || prefix.includes('+'))) {
        return;
      }
    }
    if (prefix === '' && !Number.isNaN(Number(e.target.value))) {
      setPrefix('+' + e.target.value);
    } else {
      setPrefix(e.target.value);
    }
  };

  const changeNumber = e => {
    if (e.target.value.length > prefix.length) {
      // added a digit
      const lastChar = e.target.value.slice(-1);
      if (!lastChar.match(/[0-9]/)) {
        return;
      }
    }
    setNumber(e.target.value);
  };

  return (
    <>
      <Pane display="flex" flexDirection="column" justifyContent="center" height="100%" padding={16} paddingTop={0}>
        <Text color="#fcfdfd" fontWeight="bold" fontSize="16px" paddingBottom="16px">
          SMS Verification
        </Text>
        <Pane display="flex" alignItems="center" position="relative">
          <PrefixInputField type="text" name="prefix" onChange={changePrefix} value={prefix} placeholder="+44" />
          <NumberInputField
            type="text"
            name="number"
            onChange={changeNumber}
            value={number}
            placeholder="0000 - 000000"
            marginTop="5px"
          />
        </Pane>
        <Label htmlFor="number" color="#636465" marginTop={16} display="block">
          Enter your phone number
        </Label>
        <Button
          type="button"
          appearance="primary"
          marginTop="16px"
          height={58}
          width="100%"
          backgroundColor="#e78850"
          border="none"
          borderRadius={10}
          onClick={addMobile}
          disabled={addMobileQuery.isLoading}
        >
          {addMobileQuery.isLoading ? (
            <Spinner size={16} />
          ) : (
            <Text color="#fcfdfd" fontWeight={600} fontSize={15} letterSpacing={2}>
              SEND CODE
            </Text>
          )}
        </Button>
      </Pane>
    </>
  );
};

const OTPInsertionForm = () => {
  const dispatch = useDispatch();
  const [otp, setOtp] = React.useState('');
  const [wrongOtp, setWrongOtp] = React.useState(false);
  const token = useSelector(state => state.authentication.token);
  const verifyMobileQuery = useMutation(mobileRequests.verifyRequest, {
    useErrorBoundary: true,
    onSuccess: async data => {
      if (!data) {
        setWrongOtp(true);
        return;
      }
      console.log(data);
    },
  });

  const verifyMobile = async () => {
    try {
      const updatedUser = await verifyMobileQuery.mutateAsync({
        OTP: otp,
        token,
      });
      dispatch(updateUser(updatedUser));
    } catch (error) {
      console.log(error);
      setWrongOtp(true);
    }
  };
  return (
    <Pane display="flex" flexDirection="column" justifyContent="center" height="100%" padding={16} paddingTop={0}>
      <Pane display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
        <Text color="#fcfdfd" fontWeight="bold" fontSize="16px" paddingBottom="16px">
          OTP Verification
        </Text>
        {wrongOtp && (
          <Text color="#D43D3A" fontSize="16px" paddingBottom="16px">
            Invalid Code Entered
          </Text>
        )}
      </Pane>

      <CustomOTPInput value={otp} onChange={setOtp} numInputs={6} />
      <Label color="#636465" marginTop={16} display="block">
        Enter the 6 digit code sent to your device
      </Label>
      <Button
        type="button"
        appearance="primary"
        marginTop="16px"
        height={58}
        width="100%"
        backgroundColor="#e78850"
        border="none"
        borderRadius={10}
        onClick={verifyMobile}
        disabled={verifyMobileQuery.isLoading}
      >
        {verifyMobileQuery.isLoading ? (
          <Spinner size={16} />
        ) : (
          <Text color="#fcfdfd" fontWeight={600} fontSize={15} letterSpacing={2}>
            VERIFY
          </Text>
        )}
      </Button>
    </Pane>
  );
};

const SMSVerificationPage = () => {
  const user = useSelector(state => state.authentication.user);
  const [page, setPage] = React.useState('numberInsertion');
  return (
    <Pane>
      <Pane paddingY={50}>
        <Header logoSize={170} subTitle={user?.email} />
      </Pane>
      {page === 'numberInsertion' ? <NumberInsertionForm changePage={() => setPage('OTP')} /> : <OTPInsertionForm />}
      <Support iconStyle={{ position: 'absolute', right: 0, bottom: 0 }} />
    </Pane>
  );
};

export default SMSVerificationPage;
